(() => {
  // app/scripts/product-select-size-addons-popup.js
  var customElementsName = "addon-select-size-component";
  if (!window.customElements.get(customElementsName)) {
    class AddOnSelectSize extends HTMLElement {
      constructor() {
        super();
        this.currentAddonSize = {
          id: null,
          item: null
        };
        this.items = this.querySelectorAll(".js-item");
        this.atcBtn = this.querySelector(".js-atc-btn");
        console.log("AddOnSelectSize::", this);
        if (this.noSelectSizeTriggers) return;
        this.attachEvent();
      }
      disconnectedCallback() {
        window.removeEventListener("cart:ready", (evt) => this.afterAtc(evt).bind(this));
      }
      attachEvent() {
        this.atcBtn.addEventListener("click", () => {
          const input = this.querySelector(`input.js-add-on:checked`);
          if (!input) return;
          const countInCart = parseInt(input.dataset.quantity);
          console.log("input:: ", countInCart);
          if (countInCart !== 0) {
            this.change();
          } else {
            this.add();
          }
        });
        this.eventToClickAddOns();
        this.eventToSizeSelect();
        window.addEventListener("cart:ready", (evt) => this.afterAtc(evt));
      }
      eventToSizeSelect() {
        this.addEventListener("change", (e) => {
          if (e.target.checked) {
            this.enableAtcBtn();
          }
        });
      }
      eventToClickAddOns() {
        this.selectSizeTriggers = document.querySelectorAll("#addOnsDrawer addon-component .js-addon-select-size");
        if (this.selectSizeTriggers.length == 0) {
          this.noSelectSizeTriggers = true;
          return;
        }
        this.selectSizeTriggers.forEach((trigger) => {
          trigger.addEventListener("click", (e) => {
            e.preventDefault();
            this.checkDisableAtc(trigger);
            this.open();
          });
        });
      }
      checkDisableAtc(item) {
        this.currentAddonSize.id = item.dataset.addonItemId;
        this.items.forEach((item2) => {
          if (this.currentAddonSize.item) return;
          if (item2.dataset.addonItemId == this.currentAddonSize.id) {
            this.currentAddonSize.item = item2;
          }
          return;
        });
        let anySelected = this.currentAddonSize.item ? this.currentAddonSize.item.querySelector("input.js-add-on:checked") : false;
        this.disableAtcBtn();
        if (anySelected) {
          this.enableAtcBtn();
        }
      }
      async change() {
        console.log("change::");
        this.setLoading(true);
        let input = this.currentAddonSize.item.querySelector("input.js-add-on:checked");
        if (!input) {
          this.setLoading(false);
          return;
        }
        let formData = new FormData();
        formData.append("id", input.value);
        formData.append("quantity", 0);
        formData.append("sections", input.dataset.section);
        formData.append("sections_url", input.dataset.url);
        try {
          const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            body: formData
          });
          if (!response.ok) {
            throw new Error("Something wrongs");
          }
          const resp = await response.json();
          console.log("change resp::", resp);
          let itemOnCart = resp;
          this.currentAddonSize.item.setAttribute("data-quantity", itemOnCart.quantity);
          const div = document.createElement("div");
          if (resp.sections && resp.sections[this.currentAddonSize.item.dataset.section]) {
            div.innerHTML = resp.sections[this.currentAddonSize.item.dataset.section];
            const newInput = [...div.querySelectorAll("input.js-add-on")].find((input2) => input2.id = this.currentAddonSize.item.id);
            if (newInput) this.currentAddonSize.item.value = newInput.value;
          }
          document.dispatchEvent(new CustomEvent("cart:build"));
          this.setLoading(false);
        } catch (error) {
          console.log("addons popup change error::", error);
          this.setLoading(false);
        }
      }
      async add() {
        this.setLoading(true);
        console.log("add::", this.currentAddonSize.item);
        let input = this.currentAddonSize.item.querySelector("input.js-add-on:checked");
        if (!input) {
          this.setLoading(false);
          return;
        }
        let formData = new FormData();
        formData.append("id", input.value);
        formData.append("quantity", 1);
        formData.append("sections", input.dataset.section);
        formData.append("sections_url", input.dataset.url);
        if (input.dataset.properties) {
          const addOnForProperty = input.dataset.properties.split(":");
          formData.append(`properties[${addOnForProperty[0].trim()}]`, addOnForProperty[1].trim());
        }
        try {
          const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            body: formData
          });
          if (!response.ok) {
            throw new Error("Something wrongs");
          }
          const resp = await response.json();
          let itemOnCart = resp;
          this.currentAddonSize.item.setAttribute("data-quantity", itemOnCart.quantity);
          const div = document.createElement("div");
          if (resp.sections && resp.sections[this.currentAddonSize.item.dataset.section]) {
            div.innerHTML = resp.sections[this.currentAddonSize.item.dataset.section];
            const newInput = [...div.querySelectorAll("input.js-add-on")].find((input2) => input2.id = this.currentAddonSize.item.id);
            if (newInput) this.currentAddonSize.item.value = newInput.value;
          }
          document.dispatchEvent(new CustomEvent("cart:build"));
          this.setLoading(false);
        } catch (error) {
          console.log("addons popup error::", error);
          this.setLoading(false);
        }
      }
      afterAtc(evt) {
        const cart = evt && evt.detail && evt.detail.cart ? evt.detail.cart : void 0;
        const cartItems = cart.items.map((item) => item.product_id.toString());
        [...document.querySelectorAll("addon-component .js-add-on[data-product-id]")].forEach((item, index) => {
          item.checked = cartItems.includes(item.dataset.productId);
        });
        [...document.querySelectorAll("addon-select-size-component .js-add-on[data-product-id]")].forEach((item, index) => {
          item.checked = cartItems.includes(item.dataset.productId);
          item.dataset.quantity = parseInt(item.dataset.quantity) || 0;
        });
        this.closeHandle();
        this.setLoading(false);
      }
      open() {
        const addOnsSelectSize = document.querySelector("#addOnsSelectSize");
        addOnsSelectSize.open();
      }
      closeHandle() {
        const addOnsSelectSize = document.querySelector("#addOnsSelectSize");
        addOnsSelectSize.close();
      }
      disableAtcBtn() {
        this.atcBtn.setAttribute("disabled", "disabled");
      }
      enableAtcBtn() {
        this.atcBtn.removeAttribute("disabled");
      }
      setLoading(loading = true) {
        try {
          if (!this.atcBtn) return;
          if (loading) {
            this.atcBtn.classList.add("loading");
            this.enableAtcBtn();
            const svg = document.createElement("div");
            svg.classList.add("icon-loading");
            svg.innerHTML = `
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="11"
                      cy="11"
                      r="9"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-dasharray="40 30"
                      stroke-linecap="round">
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        repeatCount="indefinite"
                        dur="0.9s"
                        values="0 11 11;360 11 11"
                        keyTimes="0;1" />
                    </circle>
                  </svg>
                  `;
            this.atcBtn.appendChild(svg);
          } else {
            this.atcBtn.classList.remove("loading");
            console.log("this.atcBtn::", this.atcBtn);
            const loadingIcon = this.atcBtn.querySelector(".icon-loading");
            if (loadingIcon && loadingIcon.parentNode === this.atcBtn) {
              this.atcBtn.removeChild(loadingIcon);
            }
            this.disableAtcBtn();
          }
        } catch (error) {
          console.log("** Error addLoadingBtnCheckout", error);
        }
      }
    }
    window.customElements.define(customElementsName, AddOnSelectSize);
  }
})();
